import { useState, useEffect } from "react";
import getMaxCLTVHELOC from "./getMaxCLTVHELOC";
import parseMoney from "utils/parseMoney";
import API from "utils/API";
import PricingEngine from "typedef/PricingEngine";
import { UseFormWatch } from "react-hook-form";
import { RegisterFormInputs } from "./useRegisterForm";

const useCalculateMaxLoan = (watch: UseFormWatch<RegisterFormInputs>) => {
  const [maxLoanAmount, setMaxLoanAmount] = useState(0);
  const estimatedHomeValue = watch().estimatedHomeValue;
  const homeValue = parseMoney(estimatedHomeValue);
  const currentLoanBalance = watch().currentLoanBalance;
  const loanBalance = parseMoney(currentLoanBalance);
  const creditScoreRange = watch().creditScoreRange;
  const creditScore = Number(creditScoreRange.split(" - ")[1]);

  const [pricingEngine, setPricingEngine] = useState<PricingEngine>();

  useEffect(() => {
    API.get<PricingEngine>(`/get-heloc-pricing-engine`).then((result) => {
      if ("error" in result) {
        return;
      } else {
        setPricingEngine(result.data);
      }
    });
  }, []);

  useEffect(() => {
    if (
      homeValue !== undefined &&
      loanBalance !== undefined &&
      creditScore !== undefined &&
      pricingEngine !== undefined
    ) {
      const maxCLTV = getMaxCLTVHELOC(pricingEngine, creditScore);
      const calculatedMaxLoanAmount = homeValue * maxCLTV - loanBalance;

      setMaxLoanAmount(calculatedMaxLoanAmount);
    }
  }, [
    creditScoreRange,
    estimatedHomeValue,
    currentLoanBalance,
    homeValue,
    loanBalance,
    creditScore,
    pricingEngine,
  ]);

  return { maxLoanAmount, pricingEngine };
};

export default useCalculateMaxLoan;
